"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const utils_1 = require("./utils");
class EkcProxy {
    constructor(proxyURL) {
        this.proxyURL = proxyURL;
        this._ekc = undefined;
    }
    bindTo(ekc) {
        this._ekc = ekc;
        return this;
    }
    /////////////////////////////////////////////////////////////////////////////
    getAddress() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this._ekc)
                return Promise.reject('EKC is not initialized!');
            const token = yield this._ekc._getPCA().acquireTokenSilent();
            const { address } = yield (0, utils_1.fetchAPI)(this.proxyURL + '/wallet/address', {
                headers: {
                    Authorization: 'Bearer ' + token,
                },
            });
            return address;
        });
    }
    signMessage(message) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this._ekc)
                return Promise.reject('EKC is not initialized!');
            const token = yield this._ekc._getPCA().acquireTokenSilent();
            const { signature } = yield (0, utils_1.fetchAPI)(this.proxyURL + '/sign/message', {
                method: 'POST',
                headers: {
                    Authorization: 'Bearer ' + token,
                },
                body: JSON.stringify({ message }),
            });
            return signature;
        });
    }
    signTransaction(transaction) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this._ekc)
                return Promise.reject('EKC is not initialized!');
            const token = yield this._ekc._getPCA().acquireTokenSilent();
            const { signature } = yield (0, utils_1.fetchAPI)(this.proxyURL + '/sign/transaction', {
                method: 'POST',
                headers: {
                    Authorization: 'Bearer ' + token,
                },
                body: JSON.stringify({
                    transaction,
                    chain: this._ekc._getProvider().networkEnum,
                }),
            });
            return signature;
        });
    }
}
exports.default = EkcProxy;
